<template>
  <div>
    <el-container>
      <el-header style="height: 10px">
      </el-header>
      <el-main style="margin: 1px">
        <el-row>
          <el-col :span="6" :offset="0">
            <el-form label-width="60px" :model="searchData" align="left" inline>
              <el-form-item :label="$t('search.sku')" prop="sku">
                <el-input v-model="searchData.sku" style="width: 100%;" type="textarea" :rows="1" placeholder=""
                  size="small"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12" :offset="1">
            <el-row>
              <el-button type="primary" size="small" icon="el-icon-search" @click="initGoods(pagination.pageSize, 1)">{{
                $t("button.search") }}</el-button>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" v-for="(data, index) in tableData" :key="data" :offset="index >= 0 ? 1 : 0">
            <el-card :body-style="{ padding: '0px', width: '192px', height: '92px' }"
              style="width: 192px; height: 92px; margin-top: 10px">
              <el-image :src="'data:image/png;base64,' + data.image"
                style="width: 100%; height: 100%; object-fit: cover;"></el-image>
            </el-card>

          </el-col>
        </el-row>

        <div class="paginationOut">
          <el-pagination background layout="prev, pager, next,jumper,sizes,total" popper-class="pageSizeSelect"
            :page-sizes="pagination.pageSizeOption" :page-size.sync="pagination.pageSize" :total="pagination.total"
            :current-page.sync="pagination.currentPage" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import moment from "moment";
import i18n from "../../i18n";
export default {
  data() {
    return {
      searchData: {
        sku: null,
        from: 0,
        pageSize: 20,
      },
      tableData: [],
      pagination: {
        total: null,
        pageSize: 20,
        currentPage: 1,
        pageSizeOption: [20, 30, 50, 100],
      },
    };
  },
  methods: {

    handleSizeChange: function (pageSize) {
      this.pagination.pageSize = pageSize;
      this.handleCurrentChange(this.pagination.currentPage);
    },
    handleCurrentChange: function (currentPage) {
      this.pagination.currentPage = currentPage;
      this.initGoods(this.pagination.pageSize, this.pagination.currentPage);
    },
    initGoods(pageSize, currentPage) {
      this.searchData.from = (currentPage - 1) * pageSize,
        this.searchData.pageSize = pageSize,
        this.getGoods(this.searchData);
      this.getGoodsNum(this.searchData);
    },
    getGoods(query) {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getGoods(query)
          .then((res) => {
            this.tableData = res;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getGoodsNum(query) {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getGoodsNum(query)
          .then((res) => {
            this.pagination.total = res;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },

  created() {
    this.initGoods(this.pagination.pageSize, this.pagination.currentPage);
  },
};
</script>

<style lang="scss" scoped>
.el-upload {
  width: 100%;
}

.el-upload .el-upload-dragger {
  width: 100%;
}
</style>